import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import type { ScopeOption } from '@hopdrive/feature-global-search';

interface RooftopFilterProps {
  /** Exactly the rooftops this user can access (the header switcher's list) */
  options: ScopeOption[];
  /** Null and undefined both mean "no rooftop picked" — the feature passes either. */
  value?: number | null;
  onChange: (customerId?: number) => void;
}

/**
 * Rooftop filter for the search results page, sized for the shared filter
 * row's extraControls slot — the dealer counterpart of admin's picker, fed by
 * the user's own rooftop list instead of an all-customers query.
 */
const RooftopFilter: React.FC<RooftopFilterProps> = ({ options, value, onChange }) => (
  <Autocomplete
    size='small'
    options={options}
    getOptionLabel={option => option.name}
    value={options.find(option => option.id === value) ?? null}
    onChange={(_event, next) => onChange(next?.id)}
    sx={{ width: 240 }}
    renderInput={params => <TextField {...params} size='small' label='Rooftop' />}
  />
);

export default RooftopFilter;
